// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2B8nc","detailsBorder":"styles_detailsBorder__3Fwtm"};